import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { links } from "../data/images";
import { PrimaryButton } from "./PrimaryButton";
export function GuaranteeSection() {
  return <section aria-labelledby="garantia-title" className="mt-14 rounded-3xl bg-navy px-6 py-10 text-center sm:px-10" data-id="element-63" data-mp="9umhmvf8vu8v">
      <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-2 border-dashed border-cream/60 text-cream" data-id="element-64" data-mp="etz61klrl9dk">
        <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-65" data-mp="jsag9wfz1lwb" />
        <span className="mt-1 text-sm font-bold" data-id="element-66" data-mp="nt2ocmd3xkr0">30 días</span>
      </div>
      <h2 id="garantia-title" className="mt-5 font-serif text-3xl font-semibold text-cream" data-id="element-67" data-mp="skcave3d07yo">
        Probalo sin riesgo durante 30 días
      </h2>
      <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-cream/85" data-id="element-68" data-mp="xjfecu3oy64j">
        Aplicá el método durante 7 noches. Si no sentís que te ayuda a ordenar tus cenas, reducir la improvisación y
        entender mejor qué le cae bien a tu cuerpo por la noche, podés solicitar la devolución dentro de los 30 días.
      </p>
      <div className="mx-auto mt-7 max-w-sm" data-id="element-69" data-mp="25pkl9tha7pe0">
        <PrimaryButton href={links.checkout} data-id="element-70" data-mp="20rsp2n9lth40">
          Acceder con garantía
        </PrimaryButton>
      </div>
    </section>;
}